import TextField from '@mui/material/TextField'
import React, { useState, useEffect,  } from 'react'
import { useNavigate, useParams,useSearchParams} from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { getUser, getUserCreditHistory,getUserCredits } from '../graphql/queries'
import { DataGrid } from '@mui/x-data-grid'
import {Typography, Box,Button,ButtonGroup, Modal, Paper, Chip, Divider} from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import CloseIcon from '@mui/icons-material/Close'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import RefundIcon from '@mui/icons-material/Undo';


const options=['Credit History','Present Credits','User Sets','Model Table']

const columns = [
  { field: 'tableIndex', headerName: '#', width:70, sortable: false, filterable: false},
  { 
    field: 'transactionId', 
    headerName: 'Transaction ID', 
    width: 200,
    sortable: false, 
    filterable: false,
  },
  { 
    field: 'amount', 
    headerName: 'Amount', 
    width: 120,
    sortable: false, 
    filterable: false,
    renderCell: (params) => {
      const amount = params.value;
      const isNegative = amount < 0;
      return (
        <span style={{
          color: isNegative ? '#d32f2f' : '#2e7d32',
          fontWeight: 'bold'
        }}>
          {isNegative ? '' : '+'}{amount}
        </span>
      );
    }
  },
  { 
    field: 'type', 
    headerName: 'Type', 
    width: 130,
    sortable: false, 
    filterable: false,
    renderCell: (params) => {
      const type = params.value;
      const colors = {
        'USER_TRANSFER': '#1976d2',
        'CREDIT': '#2e7d32',
        'REFUND': '#ed6c02',
      };
      return (
        <span style={{
          backgroundColor: colors[type] || '#757575',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '0.75rem',
          fontWeight: 'bold'
        }}>
          {type || 'CREDIT'}
        </span>
      );
    }
  },
  { 
    field: 'transferInfo', 
    headerName: 'Transfer Details', 
    width: 300,
    sortable: false, 
    filterable: false,
    renderCell: (params) => {
      const row = params.row;
      if (row.type !== 'USER_TRANSFER') return '-';
      
      const isOutgoing = row.amount < 0;
      const sourceId = row.sourceRcUserId;
      const destId = row.destinationRcUserId;
      
      if (isOutgoing) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ color: '#d32f2f' }}>→</span>
            <span style={{ fontSize: '0.85rem' }}>
              To: <strong>{destId?.substring(0, 8)}...</strong>
            </span>
          </div>
        );
      } else {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ color: '#2e7d32' }}>←</span>
            <span style={{ fontSize: '0.85rem' }}>
              From: <strong>{sourceId?.substring(0, 8)}...</strong>
            </span>
          </div>
        );
      }
    }
  },
  { field: 'createdAt', headerName: 'Created At', width: 180 ,sortable: false,filterable: false,},
]

const videoColumns = [
  { 
    field: 'thumbnail', 
    headerName: 'Thumbnail', 
    width: 120, 
    sortable: false, 
    filterable: false,
    renderCell: (params) => {
      const row = params.row;
      let thumbnailUrl = null;
      
      // Get thumbnail based on type
      if (row.type === 'VIDEO' && row.videos && row.videos.length > 0) {
        thumbnailUrl = row.videos[0].thumbnailUrl;
      } else if (row.images && row.images.length > 0) {
        thumbnailUrl = row.images[0].url;
      }
      
      if (!thumbnailUrl) {
        return <span style={{ color: '#999' }}>No image</span>;
      }
      
      return (
        <img
          src={thumbnailUrl}
          alt="Generation thumbnail"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '8px',
            objectFit: 'cover',
            border: '1px solid #ddd'
          }}
        />
      );
    }
  },
  { field: 'name', headerName: 'Name', width: 250, sortable: false, filterable: false},
  { 
    field: 'type', 
    headerName: 'Type', 
    width: 120, 
    sortable: false, 
    filterable: false,
    renderCell: (params) => {
      const type = params.value || 'PACK';
      return (
        <span style={{
          backgroundColor: type === 'VIDEO' ? '#2196f3' : '#4caf50',
          color: 'white',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '0.75rem',
          fontWeight: 'bold'
        }}>
          {type}
        </span>
      );
    }
  },
  { field: 'createdAt', headerName: 'Created At', width: 180, sortable: false, filterable: false},
]

const modelColumns=[
  { field:'name', headerName:'Name', width:400, sortable: false, filterable: false },
  {field:'image',headerName:'Banner',width:200,sortable: false,

    filterable: false ,renderCell: (params) => (
      <img
        src={params.value}
        alt="Avatar"
        style={{
          width: 'clamp(42px, 10vw, 112px)',
          height: 'clamp(42px, 10vw, 112px)',
          borderRadius: '50%',
          objectFit: 'cover',
          border: '1px solid #ddd'
        }}
      />
    ),
  },
]

const creditColumns=[
  {field:'id',headerName:'Credit ID',sortable:false,filterable:false,flex:2},
  {field:'rcEventId',headerName:'Rc Event ID',sortable:false,filterable:false, flex:2},
  {field:'amount',headerName:'Amount',sortable:false,filterable:false,flex:1},
  {field:'expiryDate',headerName:'Expiry Date',sortable:false,filterable:false,flex:2},
  ]

export default function SingleUserPage() {
  const navigate = useNavigate()
  const { id } = useParams()
  const {data } = useQuery(getUser, { variables: { userId: id } })
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedOption,setSelectedOption]=React.useState(0)
  const [modalOpen, setModalOpen] = React.useState(false)
  const [selectedRow, setSelectedRow] = React.useState(null)
  const userData = data?.getUser ?? {}
  const [formData, setFormData] = React.useState({
    email: userData.email || '',
    isPremium: userData.isPremium || false,
    role: userData.role || '',
  })
  useEffect(() => {
    setSearchParams({
      options: selectedOption.toString(),
    })  
  }, [selectedOption, setSearchParams])  


  const { data: creditData } = useQuery(getUserCreditHistory, { variables: { userId: id } })
  const { data: presentCreditsData } = useQuery(getUserCredits, { variables: { userId: id } })


  const historyData = (creditData?.getUserCreditHistory ?? []).map((item, index) => ({
  ...item,
  id: `${item.transactionId || 'no-id'}_${index}`,
  tableIndex: index + 1,
  createdAt: new Date(item.createdAt).toLocaleString(),
  }))
  const sets = [...(data?.getUser?.sets ?? [])]
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort by newest first
    .map((item, index) => ({
      ...item,
      id: item.id || index,
      createdAt: new Date(item.createdAt).toLocaleString(undefined, { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit' 
      }),
    }))
  const models = (data?.getUser?.models ?? []).map((item, index) => ({
    ...item,
    id: item.id || index,
  }))

  const presentCredits = (presentCreditsData?.getUserCredits ?? []).map((item, index) => ({
    ...item,
    id: item.id || index,
  }))


  const handleRowClick = (params) => {
    navigate(`/sets/${params.id}`)
  }
  const handleModelRowClick=(params)=>{
    navigate(`/models/${params.id}`)
  }
  const handleCreditRowClick = (params) => {
    navigate(`/credits/${params.id}`)
  }

  const handleHistoryRowClick = (params) => {
    setSelectedRow(params.row)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedRow(null)
  }

  const renderModal = () => {
    if (!selectedRow) return null;

    const getTypeIcon = (type) => {
      switch(type) {
        case 'USER_TRANSFER': return <SwapHorizIcon />
        case 'CREDIT': return <CreditCardIcon />
        case 'REFUND': return <RefundIcon />
        default: return <CreditCardIcon />
      }
    }

    const getTypeColor = (type) => {
      switch(type) {
        case 'USER_TRANSFER': return '#1976d2'
        case 'CREDIT': return '#2e7d32'
        case 'REFUND': return '#ed6c02'
        default: return '#757575'
      }
    }

    const isTransfer = selectedRow.type === 'USER_TRANSFER'
    const isOutgoing = selectedRow.amount < 0
    const isIncoming = selectedRow.amount > 0

    return (
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Paper sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 600 },
          maxHeight: '90vh',
          overflow: 'auto',
          p: 4,
          borderRadius: 2,
        }}>
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#212529' }}>
              Credit History Details
            </Typography>
            <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', p: 1 }}>
              <CloseIcon />
            </Button>
          </Box>

          {/* Transaction Type & Amount */}
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Chip
                icon={getTypeIcon(selectedRow.type)}
                label={selectedRow.type || 'CREDIT'}
                sx={{
                  backgroundColor: getTypeColor(selectedRow.type),
                  color: 'white',
                  fontWeight: 'bold'
                }}
              />
              <Typography variant="h4" sx={{
                color: isOutgoing ? '#d32f2f' : '#2e7d32',
                fontWeight: 'bold'
              }}>
                {isOutgoing ? '' : '+'}{selectedRow.amount}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Transfer Details */}
          {isTransfer && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#212529' }}>
                Transfer Information
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {isOutgoing ? <TrendingDownIcon sx={{ color: '#d32f2f' }} /> : <TrendingUpIcon sx={{ color: '#2e7d32' }} />}
                  <Typography variant="body1">
                    <strong>Direction:</strong> {isOutgoing ? 'Outgoing Transfer' : 'Incoming Transfer'}
                  </Typography>
                </Box>
                <Typography variant="body1">
                  <strong>Source User:</strong> {selectedRow.sourceRcUserId || 'N/A'}
                </Typography>
                <Typography variant="body1">
                  <strong>Destination User:</strong> {selectedRow.destinationRcUserId || 'N/A'}
                </Typography>
              </Box>
            </Box>
          )}

          <Divider sx={{ mb: 3 }} />

          {/* Transaction Details */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#212529' }}>
              Transaction Details
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Typography variant="body1">
                <strong>Transaction ID:</strong> 
                <Typography component="span" sx={{ 
                  ml: 1, 
                  fontFamily: 'monospace', 
                  backgroundColor: '#f5f5f5', 
                  p: 0.5, 
                  borderRadius: 1 
                }}>
                  {selectedRow.transactionId || 'N/A'}
                </Typography>
              </Typography>
              <Typography variant="body1">
                <strong>Credit ID:</strong> 
                <Typography component="span" sx={{ 
                  ml: 1, 
                  fontFamily: 'monospace', 
                  backgroundColor: '#f5f5f5', 
                  p: 0.5, 
                  borderRadius: 1 
                }}>
                  {selectedRow.creditId || 'N/A'}
                </Typography>
              </Typography>
              <Typography variant="body1">
                <strong>User ID:</strong> {selectedRow.userId}
              </Typography>
              <Typography variant="body1">
                <strong>Created At:</strong> {selectedRow.createdAt}
              </Typography>
              {selectedRow.isPromo && (
                <Typography variant="body1">
                  <Chip label="Promotional Credit" size="small" color="secondary" />
                </Typography>
              )}
            </Box>
          </Box>
        </Paper>
      </Modal>
    )
  }

  return (
    <Box sx={{display:'flex', flexDirection:'column', justifyContent:'flex-start', alignItems:'flex-start', gap:7, maxWidth:'1200px', mx:'auto', px:2,py:2 }}>

      <Box sx={{display:'flex', flexDirection:'row', justifyContent:'flex-start', alignItems:'center' , gap:'6px'}}>
        <PersonIcon fontSize='large' sx={{color:'#21252'}} />
          <Typography variant='h4' sx={{fontWeight:'bold', color:'#212529'}}>
          User Details
          </Typography>
      </Box>

      <Box
      sx={{
        borderRadius: 5,
        p: 4,
        backgroundColor: '#f5f5f7',
        boxShadow: 3,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 4,
        flexWrap: 'wrap',
      }}>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {[
          ['RevenueCat Customer ID', userData.rcUserId],
          ['User ID', userData.id],
          ['User Store', userData.store],
          ['Total Credit', userData.totalCredit?.total],
          ['Daily Credit', userData.totalCredit?.dailyCredit],
          ['Premium Expiry Date', userData.premiumExpiryDate],
        ].map(([label, value], i) => (
          <Typography key={i} variant="body1">
            <strong>{label}:</strong> {value ?? '-'}
          </Typography>
        ))}
      </Box>

      <Box sx={{ flex: 1 }}>
        <TextField
          InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
          fullWidth
          label="Created At"
          variant="filled"
          value={userData.createdAt || ''}
          sx={{ mb: 2 }}
        />
        <TextField
          InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
          fullWidth
          label="Premium Status"
          variant="filled"
          value={userData.isPremium ? 'Yes' : 'No'}
        />
      </Box>
    </Box>
    <Box sx={{width:'100%' }}>
      <ButtonGroup sx={{  color:'#212529'}}>
      {options.map((label, index) => (
        <Button
          key={index}
          variant={selectedOption === index ? 'contained' : 'outlined'}
          onClick={() => setSelectedOption(index)}
          sx={{ backgroundColor: selectedOption === index ? '#212529' : 'transparent',
          color: selectedOption === index ? '#fff' : '#212529',
          borderColor: '#212529',
          '&:hover': {
            borderColor: selectedOption === index ? '#f1f1f1':'#212529',
            backgroundColor: selectedOption === index ? '#212529' : '#f1f1f1',
            color: selectedOption === index ? '#fff' : '#212529',
          },
        }}
        >
          {label}
        </Button>
      ))}
    </ButtonGroup>

    {selectedOption === 0 &&(

      <Box sx={{width:'100%', py:3}}>
        <Typography variant="h6" sx={{fontWeight:'bold', color:'#21252', py:1}}>
          Credit History
        </Typography>
        <Typography variant="body2" sx={{color:'#666', mb:2}}>
          Track all credit movements including purchases, transfers, and refunds. 
          Transfer arrows show direction: → (outgoing) ← (incoming)
        </Typography>
        <DataGrid
        disableColumnMenu
        disableColumnSorting
        rows={historyData}
        columns={columns}
        rowsPerPageOptions={[5,10,25]}
        pagination
        autoHeight
        getRowHeight={() => 'auto'}
        onRowClick={handleHistoryRowClick}
        sx={{
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiDataGrid-row': {
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }
        }}
      />
      </Box>
    )}

      {selectedOption === 1 &&(

      <Box sx={{width:'100%', py:3}}>
        <Typography variant="h6" sx={{fontWeight:'bold', color:'#21252', py:1}}>Present Credits</Typography>
        <Button variant='outlined' color='success' sx={{mb:2}} onClick={()=>navigate(`/credits/create/${userData.id}`)}>
          Create
        </Button>
        <DataGrid
        disableColumnMenu
        disableColumnSorting
        columns={creditColumns}
        rows={presentCredits}
        rowsPerPageOptions={[5,10,25]}
        pagination
        autoHeight
        onRowClick={handleCreditRowClick}
      />
      </Box>
    )}

    {selectedOption === 2 &&(

      <Box sx={{width:'100%', py:3}}>
      <Typography variant="h6" sx={{fontWeight:'bold',color:'#21252', py:1}}>User Sets</Typography>
      <DataGrid
        rows={sets}
        columns={videoColumns}
        rowsPerPageOptions={[5,10,25]}
        pagination
        onRowClick={handleRowClick}
        autoHeight
        getRowHeight={() => 'auto'}
        disableColumnMenu
        disableColumnSorting
        sx={{
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
            py: 1,
          },
        }}
      />
      </Box>
    )}

    {selectedOption === 3 &&(

      <Box sx={{width:'100%', py:3}}>
      <Typography variant="h6" sx={{fontWeight:'bold',color:'#21252', py:1}}>Model Table</Typography>
      <DataGrid
        rows={models}
        columns={modelColumns}
        rowsPerPageOptions={[5,10,25]}
        pagination
        autoHeight
        getRowHeight={() => 'auto'}
        disableColumnMenu
        disableColumnSorting 
        onRowClick={handleModelRowClick}
        sx={{}}
        
      />
      </Box>
    )}
      </Box>
      
      {/* Modal */}
      {renderModal()}
    </Box>
  )
}